import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Box)`
  border-bottom: ${({ theme }) => css`1px solid ${theme.colors.lightGrey}`};
`;

export const Label = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.secondary};
    margin-bottom: ${theme.spacing(0.5)};
  `}
`;

export const Value = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.primaryBlue};
  `}
`;

export const Divider = styled(Box)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.primaryAdd6};
    margin: ${theme.spacing(1.5, 0)};
  `}
`;
